module.exports = __webpack_public_path__ + "static/media/image40.89cae893.png";